import React from 'react';
import classes from '../UI/TextList.module.css';
import {Typography} from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const TextList = props => {
    return (
        <>
        <li className={classes.list} style={{...props.sx || ''}} data-aos={props["data-aos"]}>
            <CheckRoundedIcon sx={{color: "#377dff", marginRight: "10px"}}/>
            <Typography variant="description" component="span">{props.children}</Typography>
        </li>
        </>
    )
}

export default TextList;